<template>
    <div class="container-body">
        <div class="logo-big">
            <img src="assets/images/logo_big.png" />
        </div>
        <a href="https://apps.apple.com/us/app/társkereső/id1490994095" target="_blank">
            <img src="assets/images/appstore_black.svg" />

        </a>
    </div>
</template>

<script>
    export default {
        name: "Home"
    }

</script>


